import type { ImageGridImage, InfluencerTile } from 'types';

function getImage(
  postUrl: string,
  postId: string,
  channel: string
): string {
  if (channel === 'youtube') {
    return `https://i.ytimg.com/vi/${postId}/mqdefault.jpg`;
  }

  return '';
}

function getPosts(posts, channel: string) {
  return posts.map((post): ImageGridImage => ({
    id: post.id,
    type: channel,
    assetUrl: getImage(post.url, post.id, channel),
    embedUrl: channel === 'youtube' ? `https://www.youtube-nocookie.com/embed/${post.id}` : null,
    url: post.url
  }));
}

export function getImagesFromChannel(
  influencer: InfluencerTile,
  channel: string
): Array<ImageGridImage> {
  const channelData = (influencer.channels[channel] || {});
  return getPosts(channelData.recentPosts || [], channel);
}
